import { render, staticRenderFns } from "./OvaSelect.vue?vue&type=template&id=741158f8&scoped=true"
import script from "./OvaSelect.vue?vue&type=script&lang=ts"
export * from "./OvaSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741158f8",
  null
  
)

export default component.exports